import { ErrorCode, PortalApiError } from '@afterpaytouch/portal-api/types'
import { Route, ERROR_TO_ONBOARDING_ROUTE } from '../../config/router'
import { TrackingEvent } from '../../model/monitoring'
import { ErrorHandler, CheckoutErrorContext } from './types'
import { AU_REG_ERROR_CODES } from '../../model'

export const createCheckoutStartAURegulationErrorHandler = (): ErrorHandler => {
  return {
    canHandle: (errorCode: ErrorCode, error: PortalApiError): boolean => {
      return AU_REG_ERROR_CODES.includes(errorCode)
    },

    handle: async (errorCode: ErrorCode, error: PortalApiError, context: CheckoutErrorContext): Promise<Route | undefined> => {
      context.logEvent(TrackingEvent.CHECKOUT_DECLINED, {
        isRecoverableTerminalError: false,
        errorCode,
      })

      const onboardingRouteExists = typeof ERROR_TO_ONBOARDING_ROUTE[errorCode] !== 'undefined'
      const isEligibleForCreditFacilityIntroduction = error.errorInfo?.facility_application_eligibility === 'eligible'

      if (onboardingRouteExists && isEligibleForCreditFacilityIntroduction && errorCode !== ErrorCode.ContractAcceptanceRequired) {
        return Route.GET_STARTED
      }

      return ERROR_TO_ONBOARDING_ROUTE[errorCode]
    },
  }
}
